import React from "react";

export const HOME = "HOME";
const Home = () => <div>Home Template</div>;

export default Home;
